import React from "react"
import { Container, Col, Row, Form, Button } from "react-bootstrap"
import "../BookAnAppointment/assets/styles/_index.scss"
import { Link } from "gatsby"
import PropertyManagement from '../../components/forms/property-management'
const PropertyManagementFormModule = () => {
  return (
    <section className="form-page-wrapper" id="property-management">
      <Container>
          <Row>
            <Col lg={3}></Col>
            <Col lg={6}>
              <div className="form-page-details">
                <div className="form-page-heading">
                  <div className="title-text-sm-2">book an appointment</div>
                  <h2>Let’s Talk Property Management</h2>
                  <p>Get in touch with us and we will be able to help with your query.</p>
                </div>
                <div className="form-page-form-details">
                  <PropertyManagement />
                </div>                                  
              </div>
            </Col>
            <Col lg={3}></Col>
          </Row>
      </Container>
    </section>
  )
}

export default PropertyManagementFormModule
